var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlightlySmilingActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FAB84B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 47C37.1503 47 47 37.1503 47 25C47 12.8497 37.1503 3 25 3C12.8497 3 3 12.8497 3 25C3 37.1503 12.8497 47 25 47Z",
    fill: "#FFDD67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.569 24.7074C18.5941 24.7074 20.2357 23.0657 20.2357 21.0407C20.2357 19.0156 18.5941 17.374 16.569 17.374C14.544 17.374 12.9023 19.0156 12.9023 21.0407C12.9023 23.0657 14.544 24.7074 16.569 24.7074Z",
    fill: "#664E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4323 24.7074C35.4573 24.7074 37.099 23.0657 37.099 21.0407C37.099 19.0156 35.4573 17.374 33.4323 17.374C31.4072 17.374 29.7656 19.0156 29.7656 21.0407C29.7656 23.0657 31.4072 24.7074 33.4323 24.7074Z",
    fill: "#664E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2459 31.0873C28.3059 35.2673 21.7059 35.1939 15.7659 31.0873C15.0326 30.5739 14.4459 31.4539 14.8859 32.2606C16.7193 35.1939 20.3126 37.9073 25.0059 37.9073C29.6993 37.9073 33.2926 35.2673 35.1259 32.2606C35.5659 31.4539 34.9793 30.5739 34.2459 31.0873Z",
    fill: "#664E27"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlightlySmilingActive);
export default __webpack_public_path__ + "static/media/slightlySmilingActive.0f72814c2345da0e07baa6c04664b709.svg";
export { ForwardRef as ReactComponent };